<!-- Add Clients Modal -->
<p-dialog [(visible)]="visible" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'1025px': '100vw', '640px': '100vw'}" [style]="{width: '40vw'}"
  styleClass="no-header-modal no-overflow-content" (onHide)="closePopup()">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">


    <div
      class="p-2 md:py-3 md:px-4 flex align-items-center justify-content-between relative border-bottom-1 border-300">
      <h2 class="mb-0 text-sm">{{'ADMIN.COUPON.ADD_CLIENTS' | translate}}</h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup()"></div>
    </div>
    <!-- Header -->

    <!-- Header -->
    <div class="p-2 md:p-3 flex align-items-center surface-50 relative border-bottom-1 border-300"
      *ngIf="showDownload">

      <div class="w-full">
        <mini-search [readonly]="false" [showCreateClient]="false" [showSelected]="false" (clients)="AddClient($event)"
          (createProspect)="createProspect($event)">
        </mini-search>
      </div>
      <div class="w-2rem">
        <div (click)="DownloadCSV()"
          class="ml-2 border-round border-1 border-primary cursor-pointer h-2rem w-2rem flex align-items-center justify-content-center">
          <img width="17" src="/assets/img/icons/microsoft-excel.svg" alt="Image" />
        </div>
      </div>
    </div>

    <div class="p-2 md:p-3 flex align-items-center surface-50 relative border-bottom-1 border-300"
      *ngIf="!showDownload">
      <div class="p-inputgroup inline-flex w-full mb-3 md:mb-0">
        <mini-search [readonly]="false" [showSelected]="false" class="text-sm w-full" (clients)="AddClient($event)"
          (createProspect)="createProspect($event)">
        </mini-search>
      </div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="surface-50 text-sm py-2 border-bottom-1 border-300">

      <p-scrollPanel styleClass="w-full h-25rem">
        <!-- List Item -->
        <div *ngIf="(selectedClients | async) && (selectedClients | async).length >0; else nodata">
          <div class="flex align-items-center justify-content-between p-3 border-bottom-1 border-300"
            *ngFor="let client of selectedClients | async">
            <div class="flex align-items-center justify-content-between">
              <span class="mr-3">
                <p-avatar *ngIf="client.client_iamge; else noContactPic" [image]="client.client_iamge"
                  shape="circle"></p-avatar>
                <ng-template #noContactPic>
                  <p-avatar [label]="client.client_name | titlecase | shortName" shape="circle"></p-avatar>
                </ng-template>
              </span>
              <strong class="text-primary">{{client.client_name}}</strong>
              <p class="mb-0 text-xs text-600 ml-2">- {{client.client_id}}</p>
            </div>
            <i class="fa fa-trash-alt text-600 cursor-pointer ml-3" (click)="removeClient(client)"></i>
          </div>
        </div>

        <!-- List Item -->

        <ng-template #nodata>
          <div class="text-center p-5">
            <p>{{'ADMIN.COUPON.NO_CLIENTS' | translate}}</p>
            <!-- <img src="/assets/img/empty-restrictions-img.svg" alt="No restricted clients added!" /> -->
            <img src="/assets/img/empty-restrictions-img.svg" alt="Image" />
          </div>
        </ng-template>
      </p-scrollPanel>

    </div>
    <!-- Content -->

  </ng-template>

</p-dialog>
